<template>
  <donut-chart-card
    title="산업안전보건위원회 구성 현황"
    :value="data"
    unit="건"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: 'DonutChart03',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  data () {
    return {
      graphId: 3,
      boardIds: [152],
      summaryKeys: {
        'detail' : ['산업안전보건위원회_구분', 'count'],
        'field' : ['산업안전보건위원회_사업장명', 'count'],
        'address' : ['산업안전보건위원회_구분', 'count'],
        'field_cat1' : ['산업안전보건위원회_구분', 'count'],
        'company' : ['산업안전보건위원회_구분', 'count'],
        'project' : ['산업안전보건위원회_구분', 'count'],
      },
      data: [{label: '데이터 없음', value: 0}],
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (value) {
      this.loadGraph()
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const projectIds = this.projectId ? [this.projectId] : []
      const summaryKey = this.summaryKeys[this.dataType]
      const boardIds = this.boardIds
      const dataType = this.dataType
      const dataList = await CircleGraphUtil.loadGraphPieces(this.$store, projectIds, boardIds, summaryKey, dataType)
      let value = {}
      for (const data of dataList) {
        value = CircleGraphUtil.combineCircleGraphData(value, data)
      }
      this.data = CircleGraphUtil.circleModuleWithData(value)
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
